import type {
  INeoWorkflowController,
  INeoWorkflowService,
} from "../../core/ports/driver/neoWorkflowService";

/**
 * Neo Workflow Builder controller. The workflow feature has no extra
 * presentation-layer adaptation beyond what the service provides, so the
 * controller exposes the service surface directly. Kept as its own factory
 * for consistency with the rest of the hexagon (page → controller →
 * service → repository) and to give the page a stable seam to depend on.
 */
export const NeoWorkflowControllerFactory = ({
  neoWorkflowService,
}: {
  neoWorkflowService: INeoWorkflowService;
}): INeoWorkflowController => {
  return {
    listWorkflows: neoWorkflowService.listWorkflows,
    createWorkflow: neoWorkflowService.createWorkflow,
    getWorkflowGraph: neoWorkflowService.getWorkflowGraph,
    replaceWorkflowGraph: neoWorkflowService.replaceWorkflowGraph,
    restoreLastRunGraph: neoWorkflowService.restoreLastRunGraph,
    keepCurrentGraphVersion: neoWorkflowService.keepCurrentGraphVersion,
    generateNodeOutputSchema: neoWorkflowService.generateNodeOutputSchema,
    checkNodeClinicScope: neoWorkflowService.checkNodeClinicScope,
    updateWorkflow: neoWorkflowService.updateWorkflow,
    deleteWorkflow: neoWorkflowService.deleteWorkflow,
    runWorkflow: neoWorkflowService.runWorkflow,
    getWorkflowRunProgress: neoWorkflowService.getWorkflowRunProgress,
    listWorkflowRuns: neoWorkflowService.listWorkflowRuns,
    listWorkflowRunConversations:
      neoWorkflowService.listWorkflowRunConversations,
    listWorkflowEligibleClinics: neoWorkflowService.listWorkflowEligibleClinics,
    listWorkflowEmailAddresses: neoWorkflowService.listWorkflowEmailAddresses,
    listWorkflowEmailBindings: neoWorkflowService.listWorkflowEmailBindings,
    createWorkflowEmailBinding: neoWorkflowService.createWorkflowEmailBinding,
    setWorkflowEmailBindingStatus:
      neoWorkflowService.setWorkflowEmailBindingStatus,
    setWorkflowEmailBindingSenderAllowlist:
      neoWorkflowService.setWorkflowEmailBindingSenderAllowlist,
    setWorkflowEmailBindingClinic:
      neoWorkflowService.setWorkflowEmailBindingClinic,
    deleteWorkflowEmailBinding: neoWorkflowService.deleteWorkflowEmailBinding,
  };
};
